import { AlertTriangle } from 'lucide-react';

/**
 * Shown when secPose episode assets fail to load because the episode's data is
 * defective — e.g. the calibration or estimations file is missing in R2 and the
 * worker responds 404. Mirrors PreviewDurationMismatchModal: the only safe move
 * is to hand the episode back, so the single action releases the lease and
 * returns to the dashboard. Transient failures (network / 500 / auth) are NOT
 * routed here — SecPoseViewer keeps the retry/back path for those.
 */
export function SecPoseDataErrorModal({
  reason,
  releasing,
  onRelease,
}: {
  reason: string;
  releasing: boolean;
  onRelease: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 animate-in fade-in duration-200"
      role="dialog"
      aria-modal="true"
      aria-labelledby="secpose-data-error-title"
    >
      <div
        role="document"
        className="rounded-xl border border-brand-border bg-brand-surface p-6 shadow-xl max-w-sm mx-4 animate-in zoom-in-95 duration-200"
      >
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-500/10 text-red-500">
            <AlertTriangle className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <p id="secpose-data-error-title" className="text-brand-text-primary font-medium">
              此视频数据有问题，无法标注
            </p>
            <p className="mt-2 text-sm text-brand-text-secondary">
              加载标注数据失败，release 这条视频后即可继续领取下一条。
            </p>
            <p className="mt-2 break-all rounded-md bg-brand-dark px-2 py-1 font-mono text-xs text-brand-text-secondary">
              {reason}
            </p>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button
            type="button"
            disabled={releasing}
            onClick={onRelease}
            className="rounded-lg bg-brand-orange px-4 py-2 text-sm font-medium text-white hover:bg-brand-orange-hover disabled:opacity-60"
          >
            {releasing ? 'Releasing…' : '返回首页并 release'}
          </button>
        </div>
      </div>
    </div>
  );
}
